import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CoverageAmountEnum, EMPLOYERS_LIABILITY, HIRE_AND_REWARD, TEMPORARY_COVER_STATUTORY_LIMIT_KEY, TEMPORARY_COVER_STATUTORY_LIMIT_TEXT, WORKERS_COMPENSATION_COVER, convertDayjsTimeToServerStoredTimeData, formatCurrency, truelyValueMap } from '@jove-frontend/uikit';
import dayjs from 'dayjs';
import { isBoolean, uniqueId } from 'lodash';
import { getLocalTranslation } from '../utils/i18nKit';
var CoverNameTypeEnum;

(function (CoverNameTypeEnum) {
  CoverNameTypeEnum["aggregate"] = "aggregate";
  CoverNameTypeEnum["perOccurrence"] = "occurrence";
  CoverNameTypeEnum["elDiseaseEachEmployee"] = "elDiseaseEachEmployee";
  CoverNameTypeEnum["elDiseasePolicyLimit"] = "elDiseasePolicyLimit";
  CoverNameTypeEnum["perStatute"] = "perStatute";
  CoverNameTypeEnum["additionalInsured"] = "additionalInsured";
  CoverNameTypeEnum["waiverOfSubrogation"] = "waiverOfSubrogation";
})(CoverNameTypeEnum || (CoverNameTypeEnum = {}));

var RegionRequirementsTransformToServerDataHandleTypeEnum;

(function (RegionRequirementsTransformToServerDataHandleTypeEnum) {
  RegionRequirementsTransformToServerDataHandleTypeEnum[RegionRequirementsTransformToServerDataHandleTypeEnum["editType"] = 2] = "editType";
})(RegionRequirementsTransformToServerDataHandleTypeEnum || (RegionRequirementsTransformToServerDataHandleTypeEnum = {}));

export var useCoverageData = function useCoverageData() {
  var handlehandleUploadServeRequirementCoverSpecialFields = function handlehandleUploadServeRequirementCoverSpecialFields(item) {
    if (item.amount === TEMPORARY_COVER_STATUTORY_LIMIT_KEY) {
      item.amount = null;
      item.coverage_amount_type = CoverageAmountEnum.STATUTORY_LIMIT;
    } // Special logic processing


    if (item.cover_slug === WORKERS_COMPENSATION_COVER && isBoolean(item.statutory)) {
      item.coverage_amount_type = CoverageAmountEnum.STATUTORY_LIMIT;
    }
  };

  var handleUploadServeRequirementCoverItem = function handleUploadServeRequirementCoverItem(coverItem, data) {
    var _find;

    var amount = coverItem === null || coverItem === void 0 ? void 0 : coverItem.amount;
    var limit_per_occurrence = coverItem === null || coverItem === void 0 ? void 0 : coverItem.limit_per_occurrence;
    var el_disease_each_employee = coverItem === null || coverItem === void 0 ? void 0 : coverItem.el_disease_each_employee;
    var el_disease_policy_limit = coverItem === null || coverItem === void 0 ? void 0 : coverItem.el_disease_policy_limit;
    var statutory = coverItem === null || coverItem === void 0 ? void 0 : coverItem.statutory;
    var additional_insured = coverItem === null || coverItem === void 0 ? void 0 : coverItem.additional_insured;
    var waiver_of_subrogation = coverItem === null || coverItem === void 0 ? void 0 : coverItem.waiver_of_subrogation;
    var cover_slug = coverItem[(data === null || data === void 0 ? void 0 : data.coverKey) || 'cover'];

    if (data !== null && data !== void 0 && data.handleType) {
      limit_per_occurrence = coverItem === null || coverItem === void 0 ? void 0 : coverItem.perOccurrence;
      el_disease_each_employee = coverItem === null || coverItem === void 0 ? void 0 : coverItem.diseaseEachEmployee;
      el_disease_policy_limit = coverItem === null || coverItem === void 0 ? void 0 : coverItem.diseasePolicyLimit;
      additional_insured = coverItem === null || coverItem === void 0 ? void 0 : coverItem.additionalInsured;
      waiver_of_subrogation = coverItem === null || coverItem === void 0 ? void 0 : coverItem.waiverOfSubrogation;
    }

    var item = {
      amount: !!amount || amount === 0 ? data !== null && data !== void 0 && data.convertToNumber ? Number(amount) : amount : null,
      limit_per_occurrence: !!limit_per_occurrence ? data !== null && data !== void 0 && data.convertToNumber ? Number(limit_per_occurrence) : limit_per_occurrence : null,
      el_disease_each_employee: !!el_disease_each_employee ? data !== null && data !== void 0 && data.convertToNumber ? Number(el_disease_each_employee) : el_disease_each_employee : null,
      el_disease_policy_limit: !!el_disease_policy_limit ? data !== null && data !== void 0 && data.convertToNumber ? Number(el_disease_policy_limit) : el_disease_policy_limit : null,
      statutory: !!statutory ? statutory === truelyValueMap.yes.value ? true : false : null,
      additional_insured: additional_insured ? additional_insured === truelyValueMap.yes.value : null,
      waiver_of_subrogation: waiver_of_subrogation ? waiver_of_subrogation === truelyValueMap.yes.value : null
    }; // Cover slug

    if (cover_slug) {
      item.cover_slug = cover_slug;
    } // Cover id


    var coverId = (_find = ((data === null || data === void 0 ? void 0 : data.coverList) || []).find(function (aItem) {
      return aItem.slug === cover_slug;
    })) === null || _find === void 0 ? void 0 : _find.id;

    if (coverId) {
      item.cover_id = coverId;
    } // Currency


    if (data !== null && data !== void 0 && data.currency) {
      item.currency = data === null || data === void 0 ? void 0 : data.currency;
    }

    handlehandleUploadServeRequirementCoverSpecialFields(item); // Candidate type

    if (data !== null && data !== void 0 && data.candidateType) {
      item.candidate_type = data.candidateType;
    } // Date


    item.start_date = coverItem.start_date ? convertDayjsTimeToServerStoredTimeData(dayjs(coverItem.start_date)) : null;
    item.end_date = coverItem.end_date ? convertDayjsTimeToServerStoredTimeData(dayjs(coverItem.end_date)) : null;
    return item;
  };

  var handleCoverageRequirementItemToServerData = function handleCoverageRequirementItemToServerData(coverItem, data) {
    var _find2;

    var amount = coverItem === null || coverItem === void 0 ? void 0 : coverItem.amount;
    var limit_per_occurrence = coverItem === null || coverItem === void 0 ? void 0 : coverItem.limit_per_occurrence;
    var el_disease_each_employee = coverItem === null || coverItem === void 0 ? void 0 : coverItem.el_disease_each_employee;
    var el_disease_policy_limit = coverItem === null || coverItem === void 0 ? void 0 : coverItem.el_disease_policy_limit;
    var statutory = coverItem === null || coverItem === void 0 ? void 0 : coverItem.statutory;
    var additional_insured = coverItem === null || coverItem === void 0 ? void 0 : coverItem.additional_insured;
    var waiver_of_subrogation = coverItem === null || coverItem === void 0 ? void 0 : coverItem.waiver_of_subrogation;
    var cover_slug = coverItem === null || coverItem === void 0 ? void 0 : coverItem[(data === null || data === void 0 ? void 0 : data.coverKey) || 'cover_slug'];

    if (data !== null && data !== void 0 && data.handleType) {
      limit_per_occurrence = coverItem === null || coverItem === void 0 ? void 0 : coverItem.perOccurrence;
      el_disease_each_employee = coverItem === null || coverItem === void 0 ? void 0 : coverItem.diseaseEachEmployee;
      el_disease_policy_limit = coverItem === null || coverItem === void 0 ? void 0 : coverItem.diseasePolicyLimit;
      additional_insured = coverItem === null || coverItem === void 0 ? void 0 : coverItem.additionalInsured;
      waiver_of_subrogation = coverItem === null || coverItem === void 0 ? void 0 : coverItem.waiverOfSubrogation;
    }

    var item = {
      amount: !!amount || amount === 0 ? data !== null && data !== void 0 && data.convertToNumber ? Number(amount) : amount : null,
      limit_per_occurrence: !!limit_per_occurrence ? data !== null && data !== void 0 && data.convertToNumber ? Number(limit_per_occurrence) : limit_per_occurrence : null,
      el_disease_each_employee: !!el_disease_each_employee ? data !== null && data !== void 0 && data.convertToNumber ? Number(el_disease_each_employee) : el_disease_each_employee : null,
      el_disease_policy_limit: !!el_disease_policy_limit ? data !== null && data !== void 0 && data.convertToNumber ? Number(el_disease_policy_limit) : el_disease_policy_limit : null,
      statutory: !!statutory ? statutory === truelyValueMap.yes.value ? true : false : null,
      additional_insured: additional_insured ? additional_insured === truelyValueMap.yes.value : null,
      waiver_of_subrogation: waiver_of_subrogation ? waiver_of_subrogation === truelyValueMap.yes.value : null
    }; // Cover slug

    if (cover_slug) {
      item.cover_slug = cover_slug;
    } // Cover id


    var coverId = (_find2 = ((data === null || data === void 0 ? void 0 : data.coverList) || []).find(function (aItem) {
      return aItem.slug === cover_slug;
    })) === null || _find2 === void 0 ? void 0 : _find2.id;

    if (coverId) {
      item.cover_id = coverId;
    } // Currency


    if (data !== null && data !== void 0 && data.currency) {
      item.currency = data === null || data === void 0 ? void 0 : data.currency;
    }

    handlehandleUploadServeRequirementCoverSpecialFields(item); // Candidate type

    if (data !== null && data !== void 0 && data.candidateType) {
      item.candidate_type = data.candidateType;
    }

    return item;
  };

  var generateRequirementCoverDisplayLabelWithCoverInfo = function generateRequirementCoverDisplayLabelWithCoverInfo(data, config) {
    var _truelyValueMap$2, _truelyValueMap$3;

    var _ref = (data === null || data === void 0 ? void 0 : data.coverItem) || {},
        cover_slug = _ref.cover_slug,
        amount = _ref.amount,
        limit_per_occurrence = _ref.limit_per_occurrence,
        el_disease_each_employee = _ref.el_disease_each_employee,
        el_disease_policy_limit = _ref.el_disease_policy_limit,
        statutory = _ref.statutory,
        additional_insured = _ref.additional_insured,
        waiver_of_subrogation = _ref.waiver_of_subrogation;

    var _ref2 = data || {},
        currency = _ref2.currency,
        coverNameType = _ref2.coverNameType;

    var _ref3 = config || {},
        notConvertToNA = _ref3.notConvertToNA;

    var displayText = '';

    if ([WORKERS_COMPENSATION_COVER].includes(cover_slug)) {
      var _truelyValueMap$;

      displayText = ((_truelyValueMap$ = truelyValueMap["".concat(statutory)]) === null || _truelyValueMap$ === void 0 ? void 0 : _truelyValueMap$.label) || '';
    } else {
      var calculateAmount = null;

      switch (coverNameType) {
        case CoverNameTypeEnum.aggregate:
          calculateAmount = amount;
          break;

        case CoverNameTypeEnum.perOccurrence:
          calculateAmount = limit_per_occurrence;
          break;

        case CoverNameTypeEnum.elDiseaseEachEmployee:
          calculateAmount = el_disease_each_employee;
          break;

        case CoverNameTypeEnum.elDiseasePolicyLimit:
          calculateAmount = el_disease_policy_limit;
          break;

        case CoverNameTypeEnum.additionalInsured:
          var additionalInsured = isBoolean(additional_insured) ? additional_insured ? truelyValueMap.yes.value : truelyValueMap.no.value : additional_insured;
          displayText = ((_truelyValueMap$2 = truelyValueMap["".concat(additionalInsured)]) === null || _truelyValueMap$2 === void 0 ? void 0 : _truelyValueMap$2.label) || '';
          break;

        case CoverNameTypeEnum.waiverOfSubrogation:
          var waiverOfSubrogation = isBoolean(waiver_of_subrogation) ? waiver_of_subrogation ? truelyValueMap.yes.value : truelyValueMap.no.value : waiver_of_subrogation;
          displayText = ((_truelyValueMap$3 = truelyValueMap["".concat(waiverOfSubrogation)]) === null || _truelyValueMap$3 === void 0 ? void 0 : _truelyValueMap$3.label) || '';
          break;

        default:
          break;
      }

      if (!!calculateAmount && !displayText) {
        if (calculateAmount === TEMPORARY_COVER_STATUTORY_LIMIT_KEY) {
          displayText = TEMPORARY_COVER_STATUTORY_LIMIT_TEXT;
        } else {
          displayText = formatCurrency({
            amount: calculateAmount,
            currency: currency
          });
        }
      }
    }

    return !!displayText ? displayText : notConvertToNA ? '' : cover_slug === HIRE_AND_REWARD ? 'Active' : 'N/A';
  };

  var appendCoverDisplayAmountText = function appendCoverDisplayAmountText(cover, currency, config) {
    if (!cover) return '';

    var _ref4 = cover || {},
        amount = _ref4.amount,
        perOccurrence = _ref4.perOccurrence,
        limit_per_occurrence = _ref4.limit_per_occurrence,
        diseaseEachEmployee = _ref4.diseaseEachEmployee,
        el_disease_each_employee = _ref4.el_disease_each_employee,
        diseasePolicyLimit = _ref4.diseasePolicyLimit,
        el_disease_policy_limit = _ref4.el_disease_policy_limit,
        statutory = _ref4.statutory;

    var _ref5 = config || {},
        showAll = _ref5.showAll,
        dataType = _ref5.dataType;

    var slug = (cover === null || cover === void 0 ? void 0 : cover.cover_slug) || (cover === null || cover === void 0 ? void 0 : cover.coverSlug); // Aggregate
    // Original amount field

    var amountText = generateRequirementCoverDisplayLabelWithCoverInfo({
      coverItem: {
        amount: amount,
        cover_slug: slug
      },
      currency: currency,
      coverNameType: CoverNameTypeEnum.aggregate
    });
    var list = [];

    if (slug === WORKERS_COMPENSATION_COVER) {
      var _truelyValueMap$4;

      list = ["Per statute: ".concat((truelyValueMap === null || truelyValueMap === void 0 ? void 0 : (_truelyValueMap$4 = truelyValueMap["".concat(statutory)]) === null || _truelyValueMap$4 === void 0 ? void 0 : _truelyValueMap$4.label) || 'N/A')];
    } else {
      if (showAll) {
        // Per occurrence
        list.push(generateRequirementCoverDisplayLabelWithCoverInfo({
          coverItem: {
            limit_per_occurrence: dataType === 2 ? perOccurrence : limit_per_occurrence,
            cover_slug: slug
          },
          currency: currency,
          coverNameType: CoverNameTypeEnum.perOccurrence
        }));
        list.push(amountText);

        if (slug === EMPLOYERS_LIABILITY) {
          list.push(generateRequirementCoverDisplayLabelWithCoverInfo({
            coverItem: {
              el_disease_each_employee: dataType === 2 ? diseaseEachEmployee : el_disease_each_employee,
              cover_slug: slug
            },
            currency: currency,
            coverNameType: CoverNameTypeEnum.elDiseaseEachEmployee
          }));
          list.push(generateRequirementCoverDisplayLabelWithCoverInfo({
            coverItem: {
              el_disease_policy_limit: dataType === 2 ? diseasePolicyLimit : el_disease_policy_limit,
              cover_slug: slug
            },
            currency: currency,
            coverNameType: CoverNameTypeEnum.elDiseasePolicyLimit
          }));
        }
      } else {
        list.push(amountText);
      }
    }

    return list.join(' / ');
  };

  var getCoverageLevelNameText = function getCoverageLevelNameText(config) {
    var text = '';

    if ((config === null || config === void 0 ? void 0 : config.type) === CoverNameTypeEnum.aggregate) {
      if (config !== null && config !== void 0 && config.useNewExtraction && (config === null || config === void 0 ? void 0 : config.coverSlug) === EMPLOYERS_LIABILITY) {
        text += 'Accident Coverage level (aggregate)';
      } else {
        text += "Coverage level ".concat(config !== null && config !== void 0 && config.useNewExtraction ? '(aggregate)' : '');
      }
    } else if ((config === null || config === void 0 ? void 0 : config.type) === CoverNameTypeEnum.perOccurrence) {
      if ((config === null || config === void 0 ? void 0 : config.coverSlug) === EMPLOYERS_LIABILITY) {
        text += 'Accident Coverage level (per occurrence)';
      } else {
        text += "Coverage level ".concat(config !== null && config !== void 0 && config.useNewExtraction ? '(per occurrence)' : '');
      }
    } else if ((config === null || config === void 0 ? void 0 : config.type) === CoverNameTypeEnum.elDiseaseEachEmployee) {
      text = 'Disease each employee';
    } else if ((config === null || config === void 0 ? void 0 : config.type) === CoverNameTypeEnum.elDiseasePolicyLimit) {
      text = 'Disease policy limit';
    } else if ((config === null || config === void 0 ? void 0 : config.type) === CoverNameTypeEnum.perStatute) {
      text = 'Per statute';
    } else if ((config === null || config === void 0 ? void 0 : config.type) === CoverNameTypeEnum.additionalInsured) {
      text = 'Additional insured';
    } else if ((config === null || config === void 0 ? void 0 : config.type) === CoverNameTypeEnum.waiverOfSubrogation) {
      text = 'Waiver Of Subrogation';
    }

    return text;
  };

  var getCoverAliasName = function getCoverAliasName(type, config) {
    var _getLocalTranslation = getLocalTranslation(),
        $t = _getLocalTranslation.$t;

    var text = '';

    if (type === CoverNameTypeEnum.aggregate) {
      if ((config === null || config === void 0 ? void 0 : config.coverSlug) === EMPLOYERS_LIABILITY) {
        text = $t('kit:coverages.accident_coverage_level_aggregate');
      } else {
        text = $t('kit:coverages.coverage_level_aggregate');
      }
    } else if (type === CoverNameTypeEnum.perOccurrence) {
      if ((config === null || config === void 0 ? void 0 : config.coverSlug) === EMPLOYERS_LIABILITY) {
        text = $t('kit:coverages.accident_coverage_level_per_occurrence');
      } else {
        text = $t('kit:coverages.coverage_level_per_occurrence');
      }
    } else if (type === CoverNameTypeEnum.elDiseaseEachEmployee) {
      text = $t('kit:coverages.disease_each_employee');
    } else if (type === CoverNameTypeEnum.elDiseasePolicyLimit) {
      text = $t('kit:coverages.disease_policy_limit');
    } else if (type === CoverNameTypeEnum.perStatute) {
      text = $t('kit:coverages.per_statute');
    } else if (type === CoverNameTypeEnum.additionalInsured) {
      text = 'Additional Insured';
    } else if (type === CoverNameTypeEnum.waiverOfSubrogation) {
      text = 'Waiver of Subrogation';
    }

    return text;
  };

  var getCleanCoverSelectItemData = function getCleanCoverSelectItemData(cover) {
    return {
      cover: cover,
      amount: null,
      limit_per_occurrence: null,
      el_disease_each_employee: null,
      el_disease_policy_limit: null,
      statutory: null
    };
  };

  var generateCoverageItemDisplayInfoList = function generateCoverageItemDisplayInfoList(item, config) {
    var _ref6 = item || {},
        cover_name = _ref6.cover_name,
        currency = _ref6.currency,
        cover_slug = _ref6.cover_slug,
        statutory = _ref6.statutory;

    var data = {
      coverName: cover_name,
      displayTitle: cover_name,
      coverLevelName: getCoverAliasName(CoverNameTypeEnum.aggregate, {
        coverSlug: cover_slug
      }),
      displayContent: generateRequirementCoverDisplayLabelWithCoverInfo({
        coverItem: item,
        currency: currency,
        coverNameType: CoverNameTypeEnum.aggregate
      })
    };
    var list = []; // Content

    if (cover_slug === HIRE_AND_REWARD) {
      data.displayContent = 'Active';
      list.push(data);
    } else if (cover_slug === WORKERS_COMPENSATION_COVER) {
      var _truelyValueMap$5;

      if (config !== null && config !== void 0 && config.useNewExtraction) {
        data.displayTitle += "  (".concat(getCoverAliasName(CoverNameTypeEnum.perStatute, {
          coverSlug: cover_slug
        }), ")");
      }

      data.coverLevelName = getCoverAliasName(CoverNameTypeEnum.perStatute, {
        coverSlug: cover_slug
      });
      data.displayContent = ((_truelyValueMap$5 = truelyValueMap["".concat(statutory)]) === null || _truelyValueMap$5 === void 0 ? void 0 : _truelyValueMap$5.label) || (config !== null && config !== void 0 && config.notConvertToNA ? '' : 'N/A');
      list.push(data);
    } else {
      if (config !== null && config !== void 0 && config.useNewExtraction) {
        // Per occurrence
        if (![WORKERS_COMPENSATION_COVER, HIRE_AND_REWARD].includes(cover_slug)) {
          list.push(_objectSpread(_objectSpread({}, data), {}, {
            displayTitle: "".concat(cover_name, "  (").concat(getCoverAliasName(CoverNameTypeEnum.perOccurrence, {
              coverSlug: cover_slug
            }), ")"),
            coverLevelName: getCoverAliasName(CoverNameTypeEnum.perOccurrence, {
              coverSlug: cover_slug
            }),
            displayContent: generateRequirementCoverDisplayLabelWithCoverInfo({
              coverItem: item,
              currency: currency,
              coverNameType: CoverNameTypeEnum.perOccurrence
            })
          }));
        } // Aggregate


        list.push(_objectSpread(_objectSpread({}, data), {}, {
          displayTitle: "".concat(cover_name, "  (").concat(getCoverAliasName(CoverNameTypeEnum.aggregate, {
            coverSlug: cover_slug
          }), ")"),
          coverLevelName: getCoverAliasName(CoverNameTypeEnum.aggregate, {
            coverSlug: cover_slug
          }),
          displayContent: generateRequirementCoverDisplayLabelWithCoverInfo({
            coverItem: item,
            currency: currency,
            coverNameType: CoverNameTypeEnum.aggregate
          })
        }));

        if (cover_slug === EMPLOYERS_LIABILITY) {
          // Disease each employee
          list.push(_objectSpread(_objectSpread({}, data), {}, {
            displayTitle: "".concat(cover_name, "  (").concat(getCoverAliasName(CoverNameTypeEnum.elDiseaseEachEmployee, {
              coverSlug: cover_slug
            }), ")"),
            coverLevelName: getCoverAliasName(CoverNameTypeEnum.elDiseaseEachEmployee, {
              coverSlug: cover_slug
            }),
            displayContent: generateRequirementCoverDisplayLabelWithCoverInfo({
              coverItem: item,
              currency: currency,
              coverNameType: CoverNameTypeEnum.elDiseaseEachEmployee
            })
          })); // Disease policy limit

          list.push(_objectSpread(_objectSpread({}, data), {}, {
            displayTitle: "".concat(cover_name, "  (").concat(getCoverAliasName(CoverNameTypeEnum.elDiseasePolicyLimit, {
              coverSlug: cover_slug
            }), ")"),
            coverLevelName: getCoverAliasName(CoverNameTypeEnum.elDiseasePolicyLimit, {
              coverSlug: cover_slug
            }),
            displayContent: generateRequirementCoverDisplayLabelWithCoverInfo({
              coverItem: item,
              currency: currency,
              coverNameType: CoverNameTypeEnum.elDiseasePolicyLimit
            })
          }));
        }
      } else {
        list.push(data);
      }
    }

    if (config !== null && config !== void 0 && config.useNewExtraction) {
      // Additional Insured
      list.push(_objectSpread(_objectSpread({}, data), {}, {
        displayTitle: "".concat(cover_name, "  (").concat(getCoverAliasName(CoverNameTypeEnum.additionalInsured, {
          coverSlug: cover_slug
        }), ")"),
        coverLevelName: getCoverAliasName(CoverNameTypeEnum.additionalInsured, {
          coverSlug: cover_slug
        }),
        displayContent: generateRequirementCoverDisplayLabelWithCoverInfo({
          coverItem: item,
          currency: currency,
          coverNameType: CoverNameTypeEnum.additionalInsured
        })
      })); // Waiver of Subrogation

      list.push(_objectSpread(_objectSpread({}, data), {}, {
        displayTitle: "".concat(cover_name, "  (").concat(getCoverAliasName(CoverNameTypeEnum.waiverOfSubrogation, {
          coverSlug: cover_slug
        }), ")"),
        coverLevelName: getCoverAliasName(CoverNameTypeEnum.waiverOfSubrogation, {
          coverSlug: cover_slug
        }),
        displayContent: generateRequirementCoverDisplayLabelWithCoverInfo({
          coverItem: item,
          currency: currency,
          coverNameType: CoverNameTypeEnum.waiverOfSubrogation
        })
      }));
    }

    return list;
  };

  var getCoverageIntroductionReminderTitleText = function getCoverageIntroductionReminderTitleText() {
    return 'Coverage: Per occurrence / aggregate';
  };

  var handleMSPUploadServeRequirementCoverItem = function handleMSPUploadServeRequirementCoverItem(updateCoverItem, outerItem) {
    var _outerItem$coverageBi, _updateCoverItem$appl, _updateCoverItem$appl2;

    return {
      applicable_companies: (outerItem === null || outerItem === void 0 ? void 0 : (_outerItem$coverageBi = outerItem.coverageBindCompanies) === null || _outerItem$coverageBi === void 0 ? void 0 : _outerItem$coverageBi.map(function (item) {
        return item.value;
      })) || [],
      applicable_geographic_area: {
        area_type: ((_updateCoverItem$appl = updateCoverItem.applicable_geographic_area) === null || _updateCoverItem$appl === void 0 ? void 0 : _updateCoverItem$appl.area_type) || null,
        countries: (((_updateCoverItem$appl2 = updateCoverItem.applicable_geographic_area) === null || _updateCoverItem$appl2 === void 0 ? void 0 : _updateCoverItem$appl2.countries) || []).map(function (aItem) {
          return aItem.code;
        })
      }
    };
  };

  var canEditLimitPerOccurrenceCoverage = function canEditLimitPerOccurrenceCoverage(info) {
    return (info === null || info === void 0 ? void 0 : info.useNewExtraction) && ![WORKERS_COMPENSATION_COVER, HIRE_AND_REWARD].includes(info === null || info === void 0 ? void 0 : info.coverSlug);
  };

  var canEditCommonAmountCoverage = function canEditCommonAmountCoverage(info) {
    return ![WORKERS_COMPENSATION_COVER, HIRE_AND_REWARD].includes(info === null || info === void 0 ? void 0 : info.coverSlug);
  };

  var canEditSelectAmountCoverage = function canEditSelectAmountCoverage(info) {
    return [HIRE_AND_REWARD].includes(info === null || info === void 0 ? void 0 : info.coverSlug);
  };

  var canEditElDiseaseEachEmployeeCoverage = function canEditElDiseaseEachEmployeeCoverage(info) {
    return (info === null || info === void 0 ? void 0 : info.useNewExtraction) && [EMPLOYERS_LIABILITY].includes(info === null || info === void 0 ? void 0 : info.coverSlug);
  };

  var canEditElDiseasePolicyLimitCoverage = function canEditElDiseasePolicyLimitCoverage(info) {
    return [EMPLOYERS_LIABILITY].includes(info === null || info === void 0 ? void 0 : info.coverSlug);
  };

  var canEditStatutoryCoverage = function canEditStatutoryCoverage(info) {
    return [WORKERS_COMPENSATION_COVER].includes(info === null || info === void 0 ? void 0 : info.coverSlug);
  };

  var canEditAdditionalInsuredCoverage = function canEditAdditionalInsuredCoverage(info) {
    return !!(info !== null && info !== void 0 && info.useNewExtraction);
  };

  var canEditWaiverOfSubrogationCoverage = function canEditWaiverOfSubrogationCoverage(info) {
    return !!(info !== null && info !== void 0 && info.useNewExtraction);
  };

  var generateNewEmptyCoverage = function generateNewEmptyCoverage() {
    return {
      uniqueId: uniqueId(),
      coverSlug: '',
      amount: null,
      perOccurrence: null,
      diseaseEachEmployee: null,
      diseasePolicyLimit: null,
      statutory: null,
      additionalInsured: null,
      waiverOfSubrogation: null
    };
  };

  var covertCoverageItemToUploadDataStructData = function covertCoverageItemToUploadDataStructData(item, config) {
    var _item$applicable_geog, _item$applicable_geog2, _item$applicable_geog3;

    var combineData = _objectSpread(_objectSpread(_objectSpread({}, item), handleUploadServeRequirementCoverItem(item, _objectSpread(_objectSpread({}, config), {}, {
      coverKey: (config === null || config === void 0 ? void 0 : config.coverKey) || 'cover_slug'
    }))), {}, {
      applicable_companies: (item.applicable_companies || []).map(function (aItem) {
        return aItem.value;
      }),
      organization_subsidiary: (item.organization_subsidiary || []).map(function (aItem) {
        return aItem.value;
      }),
      applicable_geographic_area: {
        area_type: ((_item$applicable_geog = item.applicable_geographic_area) === null || _item$applicable_geog === void 0 ? void 0 : _item$applicable_geog.area_type) || '',
        countries: ((_item$applicable_geog2 = item.applicable_geographic_area) === null || _item$applicable_geog2 === void 0 ? void 0 : (_item$applicable_geog3 = _item$applicable_geog2.countries) === null || _item$applicable_geog3 === void 0 ? void 0 : _item$applicable_geog3.map(function (aItem) {
          return aItem.code;
        })) || []
      }
    }); // Delete fields


    delete combineData.additionalInsured;
    delete combineData.waiverOfSubrogation;
    return _objectSpread(_objectSpread({}, combineData), {}, {
      amount: convertToNumber(combineData.amount),
      limit_per_occurrence: convertToNumber(combineData.limit_per_occurrence),
      el_disease_each_employee: convertToNumber(combineData.el_disease_each_employee),
      el_disease_policy_limit: convertToNumber(combineData.el_disease_policy_limit)
    });
  };

  var convertToNumber = function convertToNumber(data) {
    return !data && data !== 0 ? null : Number(data);
  };

  var cleanCoverageEditInfo = function cleanCoverageEditInfo() {
    return {
      is_product_missing: false,
      amount: null,
      limit_per_occurrence: null,
      el_disease_policy_limit: null,
      el_disease_each_employee: null,
      statutory: null,
      start_date: null,
      end_date: null,
      policyholder: null,
      applicable_geographic_area: {
        area_type: '',
        countries: []
      },
      organization_subsidiary: [],
      applicable_companies: []
    };
  };

  return {
    appendCoverDisplayAmountText: appendCoverDisplayAmountText,
    getCoverageLevelNameText: getCoverageLevelNameText,
    CoverNameTypeEnum: CoverNameTypeEnum,
    handleUploadServeRequirementCoverItem: handleUploadServeRequirementCoverItem,
    handlehandleUploadServeRequirementCoverSpecialFields: handlehandleUploadServeRequirementCoverSpecialFields,
    getCleanCoverSelectItemData: getCleanCoverSelectItemData,
    generateRequirementCoverDisplayLabelWithCoverInfo: generateRequirementCoverDisplayLabelWithCoverInfo,
    generateCoverageItemDisplayInfoList: generateCoverageItemDisplayInfoList,
    getCoverAliasName: getCoverAliasName,
    getCoverageIntroductionReminderTitleText: getCoverageIntroductionReminderTitleText,
    handleMSPUploadServeRequirementCoverItem: handleMSPUploadServeRequirementCoverItem,
    canEditLimitPerOccurrenceCoverage: canEditLimitPerOccurrenceCoverage,
    canEditCommonAmountCoverage: canEditCommonAmountCoverage,
    canEditSelectAmountCoverage: canEditSelectAmountCoverage,
    canEditElDiseaseEachEmployeeCoverage: canEditElDiseaseEachEmployeeCoverage,
    canEditElDiseasePolicyLimitCoverage: canEditElDiseasePolicyLimitCoverage,
    canEditStatutoryCoverage: canEditStatutoryCoverage,
    canEditAdditionalInsuredCoverage: canEditAdditionalInsuredCoverage,
    canEditWaiverOfSubrogationCoverage: canEditWaiverOfSubrogationCoverage,
    generateNewEmptyCoverage: generateNewEmptyCoverage,
    covertCoverageItemToUploadDataStructData: covertCoverageItemToUploadDataStructData,
    cleanCoverageEditInfo: cleanCoverageEditInfo,
    RegionRequirementsTransformToServerDataHandleTypeEnum: RegionRequirementsTransformToServerDataHandleTypeEnum,
    handleCoverageRequirementItemToServerData: handleCoverageRequirementItemToServerData
  };
};